import { useSelector } from 'react-redux';
import { selectUserAttributes } from '@features/auth/slice';

export function useIsVendor(): boolean {
  const attrs = useSelector(selectUserAttributes);
  return (
    attrs.entity?.some((v) => {
      const lower = v?.toLowerCase();
      return lower === 'vendor' || lower === 'facility';
    }) ?? false
  );
}
